import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { Instagram, Tiktok, Youtube, Pinterest, Linkedin, Headphones, Stars, PencilFill } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import PlatformModal from './PlatformsParts/PlatformModal'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function Platforms() {
  const [platformsModalOpen, setPlatformsModalOpen] = useState(false)
  const { campaign } = useContext(CampaignContext)
  const readOnly = useReadOnly()

  return (
    <div className="flex items-center mt-2">
      {campaign.platforms.has('instagram') && <button className={`w-7 h-7 mr-3 border-1 rounded-full bg-white text-black flex justify-center items-center`}><Instagram /></button>}
      {campaign.platforms.has('tiktok') && <button className={`w-7 h-7 mr-3 border-1 rounded-full bg-white text-black flex justify-center items-center`}><Tiktok /></button>}
      {campaign.platforms.has('youtube') && <button className={`w-7 h-7 mr-3 border-1 rounded-full bg-white text-black flex justify-center items-center`}><Youtube /></button>}
      {campaign.platforms.has('pinterest') && <button className={`w-7 h-7 mr-3 border-1 rounded-full bg-white text-black flex justify-center items-center`}><Pinterest /></button>}
      {campaign.platforms.has('linkedin') && <button className={`w-7 h-7 mr-3 border-1 rounded-full bg-white text-black flex justify-center items-center`}><Linkedin /></button>}
      {campaign.platforms.has('podcast') && <button className={`w-7 h-7 mr-3 border-1 rounded-full bg-white text-black flex justify-center items-center`}><Headphones /></button>}
      {campaign.platforms.has('other') && <button className={`w-7 h-7 mr-3 border-1 rounded-full bg-white text-black flex justify-center items-center`} title="Other"><Stars /></button>}

      {!readOnly && (
        <div>
          <button className="w-7 h-7 ml-1 bg-white text-rb-green rounded-full flex items-center justify-center" onClick={() => setPlatformsModalOpen(true)}>
            <PencilFill className='w-3 h-3'/>
          </button>
        </div>
      )}
      <PlatformModal platformsModalOpen={platformsModalOpen} setPlatformsModalOpen={setPlatformsModalOpen} />
    </div>
  )
})
